import { MIN_OUTPUT_VIDEO_ASPECT_RATIO } from '../constants'

/**
 * Creation crop types.
 */
enum CreationToolCrop {
    Original = 'CT_CROP_ORIGINAL',
    Widescreen = 'CT_CROP_WIDESCREEN',
    Tall = 'CT_CROP_TALL',
    Square = 'CT_CROP_SQUARE',
    Full = 'CT_CROP_FULL',
    Custom = 'CT_CROP_CUSTOM',
}

namespace CreationToolCrop {
    /**
     * Returns all available crop types in order.
     */
    export function all(): CreationToolCrop[] {
        return [
            CreationToolCrop.Original,
            CreationToolCrop.Widescreen,
            CreationToolCrop.Tall,
            CreationToolCrop.Square,
            CreationToolCrop.Full,
            CreationToolCrop.Custom,
        ]
    }

    /**
     * Returns the crop type's display title.
     */
    export function title(crop: CreationToolCrop): string {
        switch (crop) {
            case CreationToolCrop.Original:
                return 'Original'
            case CreationToolCrop.Widescreen:
                return 'Wide'
            case CreationToolCrop.Tall:
                return 'Tall'
            case CreationToolCrop.Square:
                return 'Square'
            case CreationToolCrop.Full:
                return 'Full'
            case CreationToolCrop.Custom:
                return 'Custom'
        }
    }

    /**
     * Returns the crop type's aspect ratio preset (if available)
     */
    export function aspectRatio(crop: CreationToolCrop): number {
        switch (crop) {
            case CreationToolCrop.Widescreen:
                return 16 / 9
            case CreationToolCrop.Tall:
                return MIN_OUTPUT_VIDEO_ASPECT_RATIO
            case CreationToolCrop.Square:
                return 1
            case CreationToolCrop.Full:
                return 4 / 3
            default:
                return 0
        }
    }
}

export default CreationToolCrop
